// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cpLD","col":"styles_col__3omNJ","actions":"styles_actions__2OQuK","conflict":"styles_conflict__3r8hg"};